import ConnectionsDirectory from '@/components/Settings/ConnectionsDirectory'
import SettingsKpiCards from '@/components/Settings/SettingsKpiCards'
import { CONNECTIONS_KPI } from '@/components/Settings/settingsKpiPlaceholders'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'

export default function SettingsConnectionsSection() {
  return (
    <>
      <SettingsKpiCards
        sectionTitle="Connection metrics"
        intro={getSettingsSectionIntro('connections-metrics')}
        items={CONNECTIONS_KPI}
      />
      <ConnectionsDirectory />
    </>
  )
}
